import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  button: {
    width: theme.spacing(9),
    height: theme.spacing(9),
  },
}));
